import React, { Component } from 'react'
import { intersection, keys } from 'ramda'
import Select from 'react-select-plus'
import Icon from 'svg-inline-react'
import Avatar from 'shared-web/src/components/Avatar'
import {
  ACTION_TYPES,
  PARTICIPANT_ADD_TYPES
} from 'app/modules/rules/constants'


const closeSRC = require('!svg-inline?removeTags=true!images/icons/times-icon.svg')

class ParticipantActionComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedParticipants: props.rule.data.item.action.options.userIds.map(Number),
      addType: props.rule.data.item.action.options.addType
    }
  }

  componentDidMount() {
    this.updateParent()
  }

  updateParent = () => {
    const isValidAction = this.state.addType && this.state.selectedParticipants.length
    this.props.setPageValidity(!!isValidAction)
    if (isValidAction) {
      this.props.updateAction({
        type: ACTION_TYPES.PARTICIPANT,
        options: {
          isAccountOwner: true,
          addType: this.state.addType,
          userIds: this.state.selectedParticipants
        }
      })
    }
  }

  getFormattedUsersOptions() {
    const userIds = Object.keys(this.props.users).map(Number)
    const archivedUserIds = Object
      .values(this.props.users)
      .filter(user => user.status === 'ARCHIVED')
      .map(user => user.id)
      .map(Number)
    const unusedParticipants = _.without(
      userIds,
      ...this.state.selectedParticipants,
      ...archivedUserIds
    )
    return unusedParticipants
      .map((user) => {
        const nameOrEmail = this.props.users[user].name ? this.props.users[user].name : this.props.users[user].email
        return { label: nameOrEmail, value: Number(user) }
      })
  }

  saveParticipant = (values) => {
    this.setState((prevState)=>{
      const newOptions = prevState.selectedParticipants.slice(0)
      const onlyValues = values.map((option) => option.value)
      newOptions.push(...onlyValues)
      newOptions.sort()

      return {
        selectedParticipants: newOptions.map(Number)
      }
    }, this.updateParent)
  }

  removeParticipant = (value) => {
    this.setState((prevState) => {
      const shouldSetAddOne = prevState.selectedParticipants.length <= 2 ? PARTICIPANT_ADD_TYPES.ONE : prevState.addType

      return {
        addType: shouldSetAddOne,
        selectedParticipants: _.without(prevState.selectedParticipants, value).map(Number)
      }
    }, this.updateParent)
  }

  addOne = () => {
    this.setState({ addType: PARTICIPANT_ADD_TYPES.ONE }, this.updateParent)
  }

  addAll = () => {
    this.setState({ addType: PARTICIPANT_ADD_TYPES.ALL }, this.updateParent)
  }

  renderSearchBar() {
    const selectOptions = {
      multi: true,
      autoFocus: true,
      options: this.getFormattedUsersOptions(),
      pageSize: 10,
      optionRenderer: this.renderSelectOption,
      onChange: this.saveParticipant,
      placeholder: 'Add a participant...'
    }

    return (
      <Select {...selectOptions} />
    )
  }

  renderSelectOption = ({ value }) => {
    const nameOrEmail = this.props.users[value].name ? this.props.users[value].name : this.props.users[value].email
    return (
      <div className="choice-dropdown-option">
        <Avatar user={this.props.users[value]} />
        <span className="choice-option-value">{nameOrEmail}</span>
        <span className="choice-option-add">+Add</span>
      </div>
    )
  }

  renderParticipantSelectionList() {
    const activeParticipantIds = intersection(
      keys(this.props.users).map(Number),
      this.state.selectedParticipants
    )

    return (
      <ul style={ { height: `${(activeParticipantIds.length * 75) / 2 + 75 }px` } } >
        {
          activeParticipantIds.map((userId, index) => {
            const userById = this.props.users[userId.toString()]
            const nameOrEmail = userById.name ? userById.name : userById.email
            return (
              <li key={`${userId}-${index}`} className="participants-list-item">
                <Avatar user={userById} />
                <span>{nameOrEmail}</span>
                <Icon src={closeSRC} className="remove" onClick={ () => this.removeParticipant(userId) }></Icon>
              </li>
            )
          })
        }
      </ul>
    )
  }

  renderOwnerTypeSelect() {
    const oneSelected = this.state.addType === PARTICIPANT_ADD_TYPES.ONE ? 'selected' : ''
    const allSelected = this.state.addType === PARTICIPANT_ADD_TYPES.ALL ? 'selected' : ''
    const addTypeCopy = {
      [PARTICIPANT_ADD_TYPES.ONE]: "One participant will be added on a rotating basis",
      [PARTICIPANT_ADD_TYPES.ALL]: "All participants will be added to the conversation"
    }

    const pillSet = () => (
      <fieldset className="drift-pill-set">
        <button className={`drift-button large ${ oneSelected }`} onClick={this.addOne}>Add One</button>
        <button className={`drift-button large ${ allSelected }`} onClick={this.addAll}>Add All</button>
      </fieldset>
    )

    return (
      <div>
        { this.state.selectedParticipants.length >= 2 && pillSet() }
        <p className="participant-rotation-helper">{addTypeCopy[this.state.addType]}</p>
      </div>
    )
  }

  render() {
    return (
      <div className="rules-choice">
        <header>
          <h1>Choose participants to add</h1>
          <p>Select which teammate(s) you want to add to a conversation as a participant.</p>
        </header>

        <div className="rules-editor-content">
          <div className="rules-choice-sidebar drift-form">
            { this.renderOwnerTypeSelect() }
          </div>

          <div className="drift-form rules-editor-selection">
            <div className="rules-choice-options">
              {this.renderSearchBar()}
            </div>

            <div className="rules-choice-selection">
              { this.renderParticipantSelectionList() }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ParticipantActionComponent



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/ActionEditor/ParticipantAction.js